<template>
	<div class="de-one-level-title" :style="wrapperStyle">
		<span class="line-tag" :style="lineStyle"></span>
		<span class="title" :style="styleObj">{{title}}</span>
		<div class="bg" :style="bgStyle"></div>
	</div>
</template>

<script>
export default {
    name: 'de-one-level-title',
    props: {
		title: {
			type: String,
			default: '一级标题'
		},
		fontObj: {
			type: Object
		},
        paddingLeft: {
            type: Number,
            default: 20
        },
        lineHeight: {
            type: Number,
            default: 60
		},
		iconColor: {
			type: String
		},
		bgWidth: {
			type: [String, Number]
		},
		bgHeight: {
			type: [String, Number]
		},
		bgMarginTop: {
			type: [String, Number]
		},
		showPic: {
			type: Boolean,
			default: true
		},
		backColor: {
			type: String
		}
	},
	computed: {
		wrapperStyle() {
			return this.backColor
			? Object.assign({}, {
				background: this.backColor
			})
			: {};
		},
		lineStyle() {
			return this.fontObj 
			? Object.assign({}, {
				height: `${this.lineHeight-6}px`,
				background: this.iconColor
			})
			: {};
		},
		styleObj() {
            return this.fontObj
			? (Object.assign({}, this.fontObj, {
				fontSize: `${this.fontObj.fontSize}px`,
                fontStyle: this.fontObj.fontStyle,
                fontFamily: this.fontObj.fontFamily,
                fontWeight: this.fontObj.fontWeight,
                color: this.fontObj.color,
                paddingLeft: `${this.paddingLeft}px`,
                lineHeight: `${this.lineHeight}px`
			}))
			: {};
		},
		bgStyle() {
			return {
				display: this.showPic ? 'inline-block' : 'none',
				width: `${this.bgWidth}px`,
				height: `${this.bgHeight}px`,
				marginTop: `${this.bgMarginTop}px`
			}
		}
	}
}
</script>

<style lang="less" scoped>
.de-one-level-title {
    .line-tag {
		margin-top: 5px;
		display: inline-block;
		width: 6px;
		// height: 30px;
		background: #E6F2FF;
		box-shadow: inset 2px 4px 20px 0 rgba(255,255,255,0.10);
		vertical-align: top;
    }
    .title {
		font-family: 'PingFangSC-Medium';
    }
    .bg {
		margin: 10px 0 0 12px;
		display: inline-block;
		width: 300px;
		height: 34px;
		vertical-align: top;
		background: url('~@/runtime-components/assets/images/title.png') no-repeat;
		background-size: cover;
    }
}
</style>